export default __webpack_public_path__ + "static/media/icCalendar.39bc3bd3.svg";